import DeleteCardModal from "./DeleteCardModal";

export default DeleteCardModal;